import React from 'react';
import { CreateAgencyWizardStepProps } from '../types';
import MembershipContractForm, { MembershipContractFormModel } from '../../../../agent/components/membership-contract-from/MembershipContractForm';
import { editMembershipContractFormModelToAgency } from '../../upsert-agency-contract-action/mappers';

const AgencyMembershipContractWizardStep: React.FC<CreateAgencyWizardStepProps> = ({
  initialData,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const onInternalSubmit = React.useCallback((formValues: MembershipContractFormModel) => {
    if (!initialData) return;

    // TODO: Fix the type in bricks
    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    const data = editMembershipContractFormModelToAgency(initialData, formValues);

    onSubmit(data, isFormDirty);
  }, [formRef, initialData, onSubmit]);

  if (!initialData) return null;

  return (
    <MembershipContractForm
      initialValues={{
        ...initialData.legal,
        ...initialData.bankAccount,
      }}
      innerRef={formRef}
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AgencyMembershipContractWizardStep;
